import { render } from "./ReopenTicketModal.vue?vue&type=template&id=00155e66"
import script from "./ReopenTicketModal.vue?vue&type=script&lang=js"
export * from "./ReopenTicketModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__